// extracted by mini-css-extract-plugin
module.exports = {"root":"NumberOfSearchers_root__YYv5f","icon":"NumberOfSearchers_icon__Ky4Ws","divider":"NumberOfSearchers_divider__A043C"};